const limitPayoutColumns = {
  data: ["BET", "BET_LIMITS", 'PAYOUT'],
  title: 'PAYOUTS_AND_LIMITS',
};

const resultColumns = {
  data: ["ROUND_ID", "RESULT", 'CHECK'],
  title: 'RESULT',
};

export {
  resultColumns,
  limitPayoutColumns,
};
